import script from "./TokenCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenCard.vue?vue&type=script&setup=true&lang=js"

import "./TokenCard.vue?vue&type=style&index=0&id=770ce3da&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770ce3da"]])

export default __exports__